// One-time Chart.js registration for the chart elements used by this module.
// Importing this module (for its side effect) ensures the registry is populated.
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);

export const formatPct = (fraction: number | null | undefined, digits = 1): string => {
    if (fraction === null || fraction === undefined || Number.isNaN(fraction)) return '—';
    return `${(fraction * 100).toFixed(digits)}%`;
};

export const formatNum = (n: number | null | undefined): string => {
    if (n === null || n === undefined || Number.isNaN(n)) return '—';
    return n.toLocaleString('en-IN');
};

// Donut slice palette — dark→light blue then greens, matching the design.
export const DONUT_PALETTE = [
    '#1b4f72',
    '#21618c',
    '#2e86c1',
    '#5499c7',
    '#7fb3d5',
    '#a9cce3',
    '#239b56',
    '#52be80',
    '#a9dfbf',
    '#d5f5e3',
];

// Legacy categorical palette (kept for any bar usage).
export const PALETTE = [
    '#4e79a7',
    '#59a14f',
    '#f28e2b',
    '#e15759',
    '#76b7b2',
    '#edc948',
    '#b07aa1',
    '#ff9da7',
    '#9c755f',
    '#bab0ac',
];

// ---- funnel color helpers --------------------------------------------------

const hexToRgb = (hex: string) => {
    const h = hex.replace('#', '');
    return {
        r: parseInt(h.substring(0, 2), 16),
        g: parseInt(h.substring(2, 4), 16),
        b: parseInt(h.substring(4, 6), 16),
    };
};

const toHex = (v: number) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0');

/** Linear interpolation between two hex colors (t in 0..1). */
export const lerpColor = (a: string, b: string, t: number): string => {
    const c1 = hexToRgb(a);
    const c2 = hexToRgb(b);
    return `#${toHex(c1.r + (c2.r - c1.r) * t)}${toHex(c1.g + (c2.g - c1.g) * t)}${toHex(
        c1.b + (c2.b - c1.b) * t
    )}`;
};

/** n blue shades from light (top of funnel) to dark navy (bottom). */
export const bluesScale = (n: number): string[] => {
    const light = '#cfe0fb';
    const dark = '#0d2b45';
    if (n <= 1) return [dark];
    return Array.from({ length: n }, (_, i) => lerpColor(light, dark, i / (n - 1)));
};
